import { render, staticRenderFns } from "./ManageAssetReviewsModal.vue?vue&type=template&id=0de640ec"
import script from "./ManageAssetReviewsModal.vue?vue&type=script&lang=js"
export * from "./ManageAssetReviewsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports